import React from 'react'
import { RatingContext } from '../../utils/RatingContext'
import { PHeading } from '@porsche-design-system/components-react'
import styles from '../../assets/styles/styles.module.css'
import { CSSTransition } from 'react-transition-group'
import clsx from 'clsx'
import { TEXT } from '../../i18n/text'

export const RatingTitle = ({ appName }: Rating.Header): React.ReactElement => {
    const completion = React.useContext(RatingContext).formCompleted
    const requestError = React.useContext(RatingContext).requestError
    const language = React.useContext(RatingContext).language

    let part: string
    if (completion && !requestError) {
        part = 'thankYou'
    } else if (completion && requestError) {
        part = 'sorry'
    } else {
        part = 'start'
    }

    if (appName === '' && !completion) {
        part = 'startWithoutApp'
    }

    return (
        <div className={clsx(styles.flexContainer, styles.flexSpaceBetween, styles.flexAlignEnd, styles.spacingL)}>
            <CSSTransition in={completion} timeout={10} classNames={{ enter: styles.dividerEnter, enterDone: styles.dividerEnterDone }}>
                <div className={clsx(styles.flexGrow1, styles.divider, { [styles.red]: !completion }, { [styles.green]: completion }, { [styles.orange]: requestError })}>
                    <CSSTransition in={completion} timeout={10} classNames={{ enter: styles.headlineEnter, enterDone: styles.headlineEnterDone }}>
                        <PHeading tag='h2' size='x-large'>
                            {completion ? TEXT[language].headline[part] : appName || TEXT[language].headline[part]}
                        </PHeading>
                    </CSSTransition>
                    <CSSTransition in={completion} timeout={10} classNames={{ enter: styles.headlineEnter, enterDone: styles.headlineEnterDone }} >
                        <PHeading tag='h4' size='medium'>
                            {TEXT[language].subHeadline[part]}
                        </PHeading>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    )
}
